/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import { literal } from '../../util.type';

/**
 * Napájecí úloha ve starém formátu pro řízení vypnutí a zapnutí zařízení.
 * @deprecated Tento formát se již nepoužívá.
 * Ponecháno pouze pro umožnění smazání.
 */
export default {
  name: literal('powerTask')
};
